import styled from 'styled-components';

export default styled.div`
  && {
    .title {
      background-color: rgba(193, 225, 141, 1);
      height: 86px;
      padding: 25px 40px;
      display: flex;
      justify-content: space-between;
      .icon-billing {
        margin-top: 5px;
        margin-right: 10px;
        font-size: 20px;
      }
      .btn-deadline-bill {
        background-color: #ff8a00;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        width: 174px;
        height: 48px;
        border-radius: 5px;
        border: none;
        color: white;
      }
      .inline {
        display: inline-block;
      }
      .t-al {
        text-align: center !important;
      }
      .ant-picker-calendar .ant-picker-calendar-mini {
        margin: 0px auto !important;
        width: 300px !important;
      }
      .choose-month-year {
        margin: 0px auto;
        margin-top: 20px;
        width: 392px;
        height: 65px;
        background-color: #ecffb8;
        border-radius: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
`;
